export class MemberFormListRequirement {
    formModuleId: string;
    memberApplicationTypeId: string;
    required: number;
    total: number;
}
